import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const CustomFieldBox = ({
  label,
  helperText,
  error = false,
  children,
  ...props
}) => {
  return (
    <Box {...props}>
      <Box
        sx={{
          position: "relative",
          bgcolor: "background.paper",
          border: "1px solid",
          borderColor: error ? "error.main" : "grey.400",
          borderRadius: 1,
          px: 1.75,
          py: 2.0625,
          transition: "border-color 0.2s",
          ":hover": {
            borderColor: error ? "error.main" : "grey.800",
          },
        }}
      >
        {/* Le label shrink */}
        <Typography
          component="span"
          variant="caption"
          sx={{
            position: "absolute",
            left: 12,
            top: -8,
            px: 0.5,
            fontSize: 9.75,
            color: error ? "error.main" : "text.secondary",
            bgcolor: "background.paper",
            fontWeight: 500,
            zIndex: 1,
            lineHeight: 1,
            pointerEvents: "none",
          }}
        >
          {label}
        </Typography>
        <Box>{children}</Box>
      </Box>
      {helperText && (
        <Typography
          sx={{
            mt: 0.5,
            fontSize: 13,
            color: error ? "error.main" : "text.secondary",
          }}
        >
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default CustomFieldBox;
